import Vue from 'vue';
import VueRouter from 'vue-router';

import store from 'app/common/store';
import dialogModule from 'app/system/dialog/dialog.vuex';

import Dialog from 'app/system/dialog/Dialog.vue';

Vue.use(VueRouter);

store.registerModule('dialog', dialogModule);

window.onload = () => {
  const dialog = new Vue({
    store,
    methods: {
      open (type, options) {
        this.$refs.dialog.open(type, options);
      },
    },
    render: h => h(Dialog, { ref: 'dialog' }),
  }).$mount('#dialog');

  global.Dialog = {
    toast: {
      success (message) {
        dialog.open('toast', { status: 'success', message });
      },
      fail (message) {
        dialog.open('toast', { status: 'fail', message });
      },
    },
  };
};



// WEBPACK FOOTER //
// ./common/dialog.js